
export enum Ciphers {
    KEYWORD = "Keyword",
    MASC = "MASC",
    CAESAR = "CAESAR"
}
